// Chakra imports
import { 
  ChakraProvider,
  Box,
  Flex,
  Image,
  Heading,
  Text,
  Button,
  Badge,
  Divider,
  List,
  ListItem,
  ListIcon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useHistory } from "react-router-dom";
import { GET_COURSES_DETAIL_BY_GUEST, GET_QUESTION_BY_EXAM_BY_GUEST } from 'store/guests'
import { pdfExampleQuestions } from "utils/pdfmake";

import eng from "assets/img/5.png";
import math from "assets/img/math.jpg";
import mathPost from "assets/img/1.png";
import mathPre from "assets/img/2.png";
import sciPost from "assets/img/3.png";
import sciPre from "assets/img/4.png";
import sci from "assets/img/sci.jpg";
import social from "assets/img/6.png";
import thai from "assets/img/7.png";

export default function CourseDetail() {
  const { id } = useParams();
  const history = useHistory();

  const dispatch = useDispatch()
  const initFetch = useCallback(() => {
    dispatch(GET_COURSES_DETAIL_BY_GUEST(id))
  }, [dispatch, id])

  useEffect(() => {
    initFetch()
    window.scrollTo(0, 0)
  }, [initFetch])

  useEffect(() => {
  return () => {
    if (pdfUrl) URL.revokeObjectURL(pdfUrl);
  };
}, [pdfUrl]);

  const examlists = useSelector((state) => state.guests.exams);
  const course = useSelector((state) => state.guests.course_detail);

  const compareNames = (a, b) => {
    const nameA = a.exam_name.toUpperCase();
    const nameB = b.exam_name.toUpperCase();
  
    return nameA.localeCompare(nameB, 'en', { numeric: true });
  };

  const sortedExamlists = examlists ? [...examlists].sort(compareNames) : [];

  const routeTakeExam = (exam_id) =>{
    let path = `/course/${course.id}/free-takeexam/${exam_id}`;
    history.push(path);
  }

  const imageSubject = (subject, classNum) => {
    let num = classNum && classNum.split(' ')[1]
    if (subject == 'คณิตศาสตร์' && num < 4) {
      return mathPre
    } else if (subject == 'คณิตศาสตร์' && num >= 4) {
      return mathPost
    }  else if (subject == 'วิทยาศาสตร์' && num < 4) {
      return sciPre
    } else if (subject == 'วิทยาศาสตร์' && num >= 4) {
      return sciPost
    } else if (subject == 'สังคมศึกษา') {
      return social
    } else if (subject == 'ภาษาอังกฤษ') {
      return eng
    } else if (subject == 'ภาษาไทย') {
      return thai
    }
  }

  const totalQuestionsQty = sortedExamlists.reduce(
    (sum, row) => sum + (parseInt(row.questions_qty) ?? 0),
    0
  );

  const [loadingQuestions, setLoadingQuestions] = useState(false)
  const [pdfUrl, setPdfUrl] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const printQuestion = async () => {
    try {
      setLoadingQuestions(true);

      const res = await dispatch(
        GET_QUESTION_BY_EXAM_BY_GUEST(sortedExamlists[0].exam_id)
      );

      const pdfUrl = await pdfExampleQuestions(res);

      setPdfUrl(pdfUrl);
      onOpen();
    } finally {
      setLoadingQuestions(false);
    }
  };

  return (
    <>
      {/* Main Layout */}
      <Box bg="gray.50" minH="100vh" p={4}>
        <Flex maxW="1200px" mx="auto" direction={{ base: "column", lg: "row" }}>
          {/* Left Content */}
          <Box flex="2" pr={{ base: 0, lg: 6 }}>
            {/* Video or Image Section */}
            <Box mb={6}>
              <Image
                src={course.url_image || imageSubject(course.subject, course.class)}
                alt={`Course `}
                w="full"
                // h="420px"
                objectFit="cover"
                borderRadius="md"
              />
            </Box>

            {/* Course Details */}
            <Heading as="h1" size="lg" mb={2}>
              {course.name}
            </Heading>
            {/* <Text whiteSpace='pre-line' color="gray.600" mb={4}>
              {course.course_desc}
            </Text> */}

            <Flex align="center" mb={4}>
              <Badge colorScheme="teal" mr={2}>
                {course.class}
              </Badge>
              <Badge colorScheme="teal" mr={2}>
                {course.subject}
              </Badge>
            </Flex>

            {/* Course Syllabus */}
            <Box>
              <Heading as="h2" size="sm" mb={2}>
                รายละเอียดข้อสอบ:
              </Heading>
              <List spacing={4}>
                {sortedExamlists ? sortedExamlists.map((row, index) => {
                    return (
                      <>
                        <ListItem key={index} pl={4}>
                          <Flex justify="space-between" align="center" direction={{ base: "column", md: "row" }}>
                            <Box flex="5" p={{ base: 1, md: 0 }}>
                              <Text fontWeight="bold">
                                {row.exam_name}
                                <Badge colorScheme="orange" ml={4}>{row.questions_qty} ข้อ</Badge>
                              </Text>
                              <Text color="gray.500">{row.exam_desc == 'null' ? '' : row.exam_desc}</Text>
                            </Box>
                            <Box flex="1" p={{ base: 1, md: 0  }}>
                            </Box>
                            {course.is_free && 
                              <Button variant="outline" minHeight='2rem' colorScheme="teal" size="sm" flex="1" onClick={() => routeTakeExam(row.exam_id)}>
                                เข้าทำข้อสอบ
                              </Button>
                            }
                          </Flex>
                        </ListItem>
                        <Divider />
                      </>
                    );
                  }) : null}
              </List>
            </Box>
          </Box>

          {/* Right Sidebar */}
          <Box
            flex="1"
            bg="white"
            p={6}
            boxShadow="lg"
            borderRadius="md"
            maxH="fit-content"
          >
            {/* Pricing Section */}
            
            {course.sale_price ? (
              <>
                <Text fontWeight="bold" fontSize="2xl" color="teal.600">
                  ฿{course.sale_price}.00 บาท
                </Text>
                <Text
                  as="s"
                  color="gray.500"
                  fontSize="sm"
                  textDecoration="line-through"
                >
                  ฿{course.original_price}.00 บาท
                </Text>
              </>
            ) : (
              <Text fontWeight="bold" fontSize="2xl" color="teal.600">
                ฿{course.original_price}.00 บาท
              </Text>
            )}
            <a href='https://line.me/R/ti/p/%40838jyolz' target="_blank">
              <Button colorScheme="teal" size="lg" w="full" mt={4} mb={4}>
                ซื้อชุดข้อสอบผ่าน Line
              </Button>
            </a>
            <Button
              colorScheme='gray'
              size="lg" w="full" mb={4}
              onClick={printQuestion}
              isLoading={loadingQuestions}
              loadingText='ตัวอย่างข้อสอบ'
            >
              ตัวอย่างข้อสอบ
            </Button>

            {/* <Button variant="outline" colorScheme="teal" size="lg" w="full">
              ทดลองทำข้อสอบฟรี
            </Button> */}

            <Box mt={5}>
              <Heading as="h2" size="sm" mb={2}>
                สิ่งที่คุณจะได้รับ:
              </Heading>
              <List spacing={2} mb={4}>
                <ListItem key='qty' pl={4}>
                  <ListIcon as={CheckCircleIcon} color="teal.500" />
                  ข้อสอบทั้งหมด {sortedExamlists.length} ชุด รวม {totalQuestionsQty} ข้อ
                </ListItem>
                {course.description && course.description.split('\n').map((item, index) => (
                  <ListItem key={index} pl={4}>
                    <ListIcon as={CheckCircleIcon} color="teal.500" />
                    {item.replace(/^-\s*/, '')}
                  </ListItem>
                ))}
              </List>
            </Box>

            {/* Course Info
            <Box mt={6}>
              <Text fontSize="sm" color="gray.600" mb={2}>
                ระยะเวลาของคอร์ส:
              </Text>
              <Text fontSize="sm" color="gray.600">
                เวลาเรียน: 6 ชั่วโมง
              </Text>
              <Text fontSize="sm" color="gray.600">
                สอน: 38 หน่วย
              </Text>
            </Box> */}
            <Modal isOpen={isOpen} onClose={onClose} size="6xl">
              <ModalOverlay />
              <ModalContent h="90vh">
                <ModalHeader>ข้อสอบตัวอย่าง</ModalHeader>
                <ModalCloseButton />
                <ModalBody p={0}>
                  {pdfUrl && (
                    <iframe
                      src={pdfUrl}
                      width="100%"
                      height="100%"
                      style={{ border: "none" }}
                    />
                  )}
                </ModalBody>
              </ModalContent>
            </Modal>


          </Box>
        </Flex>
      </Box>
    </>
  );
}
